<ng-template #projected><ng-content></ng-content></ng-template>

@if (toast) {
  <!-- floating card layout (workspace message stack) -->
  <div
    class="iu-banner-toast"
    [ngClass]="['iu-banner-toast-' + severity, leaving ? 'iu-banner-toast-leaving' : '']"
    [attr.role]="severity === 'error' ? 'alert' : 'status'"
    (mouseenter)="pauseCloseDelay()"
    (mouseleave)="resumeCloseDelay()"
    (click)="cancelCloseDelay($event)"
    data-cy="banner">
    <span class="iu-banner-toast-icon" (click)="showHiddenMessage($event)" aria-hidden="true">
      <i [class]="toastIcon"></i>
    </span>
    <div class="iu-banner-toast-body">
      @if (title) {
        <div class="iu-banner-toast-title" data-cy="banner-title">{{ title }}</div>
      }
      <div
        #toastText
        class="iu-banner-toast-text"
        [class.iu-banner-toast-text-clamped]="!expanded"
        [class.iu-banner-toast-text-fade]="isOverflowing && !expanded"
        data-cy="banner-message">
        <ng-container [ngTemplateOutlet]="projected" />
      </div>
      @if (hiddenMessageDisplay) {
        <pre class="iu-banner-hidden-message" [innerHTML]="hiddenMessage"></pre>
      }
      @if (isOverflowing || severity === 'error') {
        <div class="iu-banner-toast-actions">
          @if (isOverflowing) {
            <button type="button" class="iu-banner-toast-link" data-cy="banner-toggle-btn" (click)="toggleExpanded($event)">
              {{ (expanded ? 'notification.less' : 'notification.more') | translate }}
            </button>
          }
          @if (severity === 'error') {
            <button type="button" class="iu-banner-toast-link" data-cy="banner-copy-btn" (click)="copyMessage($event)">
              <i [class]="copied ? 'icon-check' : 'icon-copy'" aria-hidden="true"></i>
              {{ (copied ? 'joinFiles.tooltip_copied' : 'generic.copy') | translate }}
            </button>
          }
        </div>
      }
    </div>
    @if (closeable) {
      <button
        type="button"
        class="iu-banner-toast-close"
        data-cy="banner-close-btn"
        [attr.aria-label]="'generic.close' | translate"
        [attr.title]="'generic.close' | translate"
        (click)="closeBanner($event)">
        <i class="icon-close" aria-hidden="true"></i>
      </button>
    }
  </div>
} @else {
  <div
    [ngClass]="[
      'iu-banner',
      type === 'success' ? 'iu-success' : '',
      type === 'error' ? 'iu-error' : '',
      type === 'message' ? 'iu-message' : '',
      type === 'warning' ? 'iu-warning' : '',
      position === 'top' ? 'iu-top' : '',
      position === 'bottom' ? 'iu-bottom' : '',
    ]"
    (click)="cancelCloseDelay($event)"
    data-cy="banner">
    @if (closeable) {
      <i
        class="icon-close"
        style="cursor: pointer"
        (click)="closeBanner($event)"
        data-cy="banner-close-btn"
        aria-hidden="true"></i>
    }
    <div class="iu-banner-message" data-cy="banner-message">
      <i
        class="{{
          icon !== undefined
            ? 'iu-banner-icon ' + icon
            : type === 'success'
              ? 'iu-banner-icon fa-lg fas fa-check'
              : type === 'message'
                ? 'iu-banner-icon fa-lg far fa-sticky-note'
                : 'iu-banner-icon fa-lg fas fa-exclamation-triangle'
        }}"
        (click)="showHiddenMessage($event)"
        aria-hidden="true"></i>
      <span class="iu-banner-message-text"> <ng-container [ngTemplateOutlet]="projected" /> </span>
    </div>
    @if (hiddenMessageDisplay) {
      <div>
        <pre class="iu-banner-hidden-message" [innerHTML]="hiddenMessage"></pre>
      </div>
    }
  </div>
}
